import { ReactNode } from "react"
import { Link } from "react-router-dom"
import { classNames } from "../../style/common"

export type ItemOverviewLinkProps = {
    imageSrc: string,
    imageAlt: string,
    linkTo: string,
    description: string,
    subText: ReactNode,
    heightClass?: string | undefined,

    clickDisabled?: boolean,
    clickArea?: "parent" | "image",
    clickType?: "link" | "click",
    onLeftClick?: () => void,
    onRightClick?: () => void,
    route?: string
}

export function ProductOverviewLink(props: ItemOverviewLinkProps) {
    return (
        <div className="group relative">
            <div className={
                classNames(
                    "w-full overflow-hidden rounded-md group-hover:opacity-75 bg-tertiary/60 shadow",
                    props.heightClass ? props.heightClass : "h-56 lg:h-72 xl:h-80"
                )
            }>
                <img
                    src={props.imageSrc}
                    alt={props.imageAlt}
                    loading="lazy"
                    className="h-full w-full object-contain p-5 object-center"
                />
            </div>
            <h3 className="mt-4 text-sm font-semibold">
                <Link to={props.linkTo} className="">
                    <span className="absolute inset-0" />
                    {props.description}
                </Link>
            </h3>
            <p
                className="mt-1 text-sm">
                {props.subText}
            </p>
        </div>
    )
}